import { observer } from 'mobx-react';
import React from 'react';

import { BooleanKeys } from 'framework/typescript-integration';
import { i18n } from 'core/localization';

export interface YesNoEditorProps<T extends object, K extends BooleanKeys<T>> {
	disabled?: boolean;
	model?: T;
	field?: K;
	onClick?: (e: React.MouseEvent) => void;
	value?: boolean;
	onChange?: (value: boolean) => void;
}

export function yesNoRenderer(value: boolean) {
	return value ? i18n('Yes') : i18n('No');
}

export const YesNoEditor = observer(<T extends object, K extends BooleanKeys<T>>(props: YesNoEditorProps<T, K>) => {
	const { model, field } = props;
	const value = props.value !== undefined ? props.value : !!model[field];

	const toggleValue = React.useCallback(
		(e: React.MouseEvent) => {
			if (props.onChange) {
				props.onChange(!value);
			} else {
				model[field] = !model[field] as T[K];
			}
			props.onClick?.(e);
		},
		[model, field, value],
	);

	return <div onClick={!props.disabled ? toggleValue : null}>{yesNoRenderer(value)}</div>;
});
